<div
  class="relative flex h-[260px] justify-end rounded-lg bg-greyscale-200 bg-cover bg-center p-6"
  [ngStyle]="{
    'background-image': tripService.trip()?.imagePath
      ? 'url(' + tripService.trip()?.imagePath + ')'
      : '',
  }"
>
  @if (!tripService.trip()?.imagePath) {
    <div class="absolute inset-0 flex items-center justify-center pb-12">
      <app-greentripper-pin-icon
        styleClass="w-12 h-12 text-greyscale-400 ml-[7px]"
      />
    </div>
  }
  <p-fileupload
    name="image"
    accept="image/jpeg, image/png, image/jpg"
    [maxFileSize]="fileUploadMaxSize"
    (onSelect)="onFileChange($event)"
    [showUploadButton]="false"
    [showCancelButton]="false"
    mode="basic"
    chooseIcon="pi pi-upload"
    [auto]="true"
    [chooseLabel]="'calculator.updateImage' | transloco"
    chooseStyleClass="!bg-primary-50 !text-primary-500 !border !border-primary-500 hover:!bg-primary-100"
  >
  </p-fileupload>
</div>
